import { AllianceOverview, AllianceStatus } from './alliance';

export const alphabeticalSortOptions = ['az', 'za'] as const;
export type AlphabeticalSortOption = (typeof alphabeticalSortOptions)[number];

export const allianceCountSortOptions = ['allianceAsc', 'allianceDesc'] as const;
export type AllianceCountSortOption = (typeof allianceCountSortOptions)[number];

export const publishedAtSortOptions = ['publishedAtAsc', 'publishedAtDesc'] as const;
export type PublishedAtSortOption = (typeof publishedAtSortOptions)[number];

export const sortOptions = [
  ...alphabeticalSortOptions,
  ...allianceCountSortOptions,
  ...publishedAtSortOptions,
] as const;
export type SortOption = (typeof sortOptions)[number];

export type JobSortField = 'title' | 'published_at';

export type SortDirection = 'asc' | 'desc';

export interface JobSortOrder {
  field: JobSortField;
  direction: SortDirection;
}

export interface FreelancerSearchResult {
  id: string;
  first_name: string;
  last_name: string | null;
  job_title?: string | null;
  service_category_slugs: string[];
  avatar_url?: string | null;
  bio?: string | null;
  city?: string | null;
  alliance_count: number;
  recent_alliances: Array<AllianceOverview> | null;
  full_access: boolean;
  alliance_status: AllianceStatus;
  overall_rating: number;
  reviews_count: number;
  projects_count: number;
  distance?: number | null;
}
